module.exports = __webpack_public_path__ + "img/sort_desc_disabled.png?d5822d9c4f79d5d3bccc5d4d95c49d95";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pages/img/icons/sort_desc_disabled.png
// module id = 281
// module chunks = 0